import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { deleteArticleList } from "../../../api/ApiArticle";
import { repositoryWeb } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

const DeleteView = ({ idItem, onSearch }: DeleteProduct) => {
  const handleDeleteProduct = async () => {
    try {
      const response = await repositoryWeb.post(
        `/TblArticlePos/delete`,
        idItem
      );

      console.log("Delete response:", response);

      // Kiểm tra response thành công
      if (response && (response.success || response.httpStatusCode === 200)) {
        NotificationExtension.Success("Xóa bài viết thành công!");
      } else {
        NotificationExtension.Fails(
          response?.message || "Có lỗi xảy ra khi xóa bài viết"
        );
      }

      modals.closeAll();
      onSearch();
    } catch (error: any) {
      console.error("Delete error:", error);

      // Xử lý các loại lỗi khác nhau
      if (error.response?.status === 500) {
        NotificationExtension.Warn("Có lỗi server, vui lòng thử lại sau");
      } else if (error.response?.status === 404) {
        NotificationExtension.Warn("Dữ liệu không tồn tại hoặc đã được xóa");
      } else {
        NotificationExtension.Fails("Lỗi kết nối hoặc server không phản hồi");
      }

      modals.closeAll();
    }
  };

  return (
    <div>
      <Text size="24px" fw={500} mt={5}>
        Bạn có chắc chắn muốn xóa các danh mục bài viết này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDeleteProduct}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  onSearch: () => void;
};

export default DeleteView;
